/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product group.
 */
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import helpers from './../../../utils/helpers';
import reportService from './../../../services/report';
import exciseEntryModal from './../../../components/exciseEntryModal/exciseEntryModal.vue';
import store from './../../../store';

export default {
  data() {
    return {
      excisePeriod: {
        monthName: 'MM/YYYY',
      },
      exciseReports: [],
      helsedirReport: [],
      infinitumReport: [],
      exciseDateRange: moment(),
      loadingExcise: false,
      loading: false,
      closeLoading: false,
      activeNames: [0],
      exciseEntryDate: null,
      tabIndex: '1',
    };
  },

  created() {
    this.show();
  },

  mounted() {
    this.urlCurrentTab();
    this.assignTab(this.tabIndex);
  },

  computed: {
    ...mapGetters({
      account: 'account',
      excisePeriods: 'paginatedExcisePeriods',
    }),

    hasExcise() {
      let hasModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'Excise') {
            hasModule = true;
          }
        }
      }
      return hasModule;
    },
  },

  watch: {
    excisePeriod(excisePeriod) {
      const date = new Date(excisePeriod.calendarMonth);
      this.exciseEntryDate = `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}`;
    },

    $route() {
      this.urlCurrentTab();
    },

    tabIndex(value) {
      this.assignTab(value);
    },
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalSize: 'SET_MODAL_SIZE',
    }),

    assignTab(value) {
      let tab = '';
      if (value === '2') {
        tab = '#entries';
      } else {
        tab = '#info';
      }
      history.pushState({}, null, `/#${this.$route.path}${tab}`);
    },

    urlCurrentTab() {
      if (this.$router.currentRoute.hash === '#entries') {
        this.tabIndex = '2';
      } else {
        this.tabIndex = '1';
      }
    },

    /**
     * Fetches the product group object for editing.
     */
    show() {
      this.loading = true;
      reportService.showExcisePeriod(store.state.route.params.id).then((excisePeriod) => {
        this.excisePeriod = excisePeriod;
        this.showReports();
      });
    },

    showReports() {
      if (this.excisePeriod.calendarMonth != null) {
        this.exciseReports = [];
        Promise.all([reportService.checkExportFlag(this.excisePeriod.calendarMonth)]).then((data) => {
          if (data[0].data > 0) {
            this.loading = false;
            this.$confirm(data[0].message, 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
            }).then(() => {
              this.showExciseModal(moment(this.excisePeriod.calendarMonth).format('YYYY-MM'));
            }).catch(() => {});
          } else {
            this.showExcise();
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.exciseReports = [];
        this.loading = false;
      }
    },

    showExcise() {
      this.loading = true;
      Promise.all([
        reportService.excises(this.excisePeriod.calendarMonth),
        reportService.helsedir(this.excisePeriod.calendarMonth),
        reportService.infinitum(this.excisePeriod.calendarMonth),
      ]).then((data) => {
        this.exciseReports = data[0];
        this.helsedirReport = data[1];
        this.infinitumReport = (typeof data[2] === 'object') ? Object.values(data[2]) : [];
        this.loading = false;
      });
    },
    getHelsedirReportByPeriod(period) {
      const data = this.helsedirReport.find(h => h.period === period);
      return data.entries || null;
    },
    getInfinitumReportByPeriod(period) {
      const data = this.infinitumReport.find(h => h.period === period);
      return data.entries || null;
    },
    showExciseModal(month) {
      this.setModalProps({
        month,
      });
      this.setModalSize('100%');
      this.toggleModal(true);
      this.setModalContent(() => exciseEntryModal);
    },

    closePeriod() {
      this.$confirm(this.$t('static.reports.fees.confirm.message'), this.$t('static.reports.fees.confirm.title'), {
        confirmButtonText: this.$t('static.reports.fees.confirm.button'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        this.closeLoading = true;
        reportService.closeExcisePeriod(store.state.route.params.id).then((excisePeriod) => {
          this.excisePeriod = excisePeriod;
          this.showExcise();
          this.closeLoading = false;
          this.$message({
            message: this.$t('static.reports.fees.closeSuccessMessage'),
            type: 'success',
          });
        });
      }).catch(() => {});
    },
    /**
     * Downloads the reports.
     */
    downloadBrodReport(closedAt) {
      const params = {};
      if (this.excisePeriod.calendarMonth) {
        params.month = moment(this.excisePeriod.calendarMonth).format('YYYY-MM-DD');
      }
      params.closed_at = closedAt;

      window.open(helpers.buildUrl(`${process.env.API_LOCATION}/reports/brod/export/`, {
        token: localStorage.getItem('id_token'),
        ...params,
      }));
    },
    /**
     * Downloads the reports.
     */
    downloadExciseReport(closedAt, type = 'excel') {
      const params = {};
      params.type = type;
      if (this.excisePeriod.calendarMonth) {
        params.month = moment(this.excisePeriod.calendarMonth).format('YYYY-MM-DD');
      }
      params.closed_at = closedAt;

      Promise.all([reportService.checkExportFlag(this.excisePeriod.calendarMonth)]).then((data) => {
        if (data[0].data > 0) {
          this.showExciseModal(moment(this.excisePeriod.calendarMonth).format('YYYY-MM'));
        } else {
          window.open(helpers.buildUrl(`${process.env.API_LOCATION}/reports/excise_entries/export/`, {
            token: localStorage.getItem('id_token'),
            ...params,
          }));
        }
      });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  components: {
    VExciseEntry: require('./../../../components/exciseEntry/exciseEntry.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/exciseReport/exciseReport.js